import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (ticketId, ticket) =>
  f3tch(`/crm/tickets/${ticketId}/`)
    .profile(profile())
    .body(ticket)
    .patch();
